import DownloadPopup from "components/core/modal-components/DownloadPopup";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { CF_URLS } from "services/api/endpoints";
import { selectAuth } from "store/slices";
import { ERROR_TYPES, downloadOptionPdf } from "utils/constants";
import {
  dataDogErrorLog,
  findErrorMessage,
  getUserName,
  handleRefId,
  printReport
} from "utils/helpers";

export default function DownloadReportModal({
  isVisible,
  setIsVisible,
  printRequestBody,
  currentBranch,
  setIsLoading,
  throwError,
  setThrowError,
  throwErrorMessage,
  setThrowErrorMessage,
  reportCFUrl,
  setReportCFUrl
}) {
  const { auth } = useSelector(selectAuth);
  const { t } = useTranslation();
  const [selectedValue, setSelectedValue] = useState(downloadOptionPdf);

  //handle download
  const handleDownload = async () => {
    try {
      setIsLoading(true);
      setThrowError(false);
      const reqBody = JSON.stringify({
        main_district_id: printRequestBody.main_district_id,
        district_name: currentBranch.name.replace("_", " "),
        customer_id: printRequestBody.customer_id,
        catalog_item_code: printRequestBody.catalog_item_code,
        active_recurring_charges_flag:
          printRequestBody.active_recurring_charges_flag,
        monthly_review_flag: printRequestBody.monthly_review_flag,
        recurring_transaction_id: printRequestBody.recurring_transaction_id,
        user_name: getUserName(auth?.user),
        report_format: selectedValue?.type?.toUpperCase()
      });
      let reportResponse = await printReport(
        reqBody,
        `${CF_URLS.printReports.billing.recurringChargeReport}`
      );
      if (!reportResponse.success) {
        setThrowErrorMessage(reportResponse.error);
        setThrowError(true);
      }
    } catch (e) {
      const { refId, message } = handleRefId(
        e.message || findErrorMessage(ERROR_TYPES.ISSUE)
      );
      setThrowErrorMessage(message);
      setThrowError(true);
      dataDogErrorLog(
        message,
        CF_URLS.printReports.billing.recurringChargeReport,
        {
          error: e
        },
        refId
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    setThrowError(false);
    setIsVisible(false);
    setReportCFUrl("");
  };

  return (
    <DownloadPopup
      title={t("common.downloadReport")}
      showPrintModal={isVisible}
      cfUrl={reportCFUrl}
      onCancleClick={handleCancel}
      onDownloadClick={handleDownload}
      setSelectedValue={setSelectedValue}
      setThrowError={setThrowError}
      throwError={throwError}
      throwErrorMessage={throwErrorMessage}
    />
  );
}
